// extracted by mini-css-extract-plugin
export default {"addForm":"addForm_addForm__w95qj","formControl":"addForm_formControl__yR9fy","list":"addForm_list__6tlC-","btnWrpper":"addForm_btnWrpper__Ic1eG"};